export default function DataLimitSection() {
  return (
    <section className="ds-container py-14 md:py-20">
      <div className="rounded-2xl border border-accent-200 bg-accent-50/70 p-5 md:p-8">
        <div className="flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-background-50 text-accent-600 ring-1 ring-accent-200">
            <i className="ri-alert-line text-2xl" />
          </span>
          <div>
            <h2 className="text-lg text-foreground-950 md:text-xl">資料限制說明</h2>
            <p className="mt-2 text-base leading-relaxed text-foreground-700">
              本工具使用公開資料進行快速健診，不包含 Google Business Profile 後台的搜尋曝光、電話點擊、路線規劃等私有數據。
            </p>
            <p className="mt-2 text-base leading-relaxed text-foreground-600">
              若需要上述後台成效數據與更完整的診斷，可進一步預約人工深度健診。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}